module.exports = __webpack_public_path__ + "img/ZEBUINO.ea6226e4.jpeg";